import React from 'react';
import HorseProfileClassic from './HorseProfileClassic';
import HorseProfileModern from './HorseProfileModern';
import { useChartLayout } from './useChartLayout';

/**
 * Thin shell that picks the chart layout the user opted into. The two
 * concrete implementations are completely independent React components —
 * data hooks live inside each one rather than being lifted here, so the
 * non-selected variant never fires queries. That keeps the toggle's
 * runtime cost at zero while we A/B the two surfaces.
 *
 * Telemetry (chart_layout_viewed / _switched / _stuck) is emitted by
 * useChartLayout itself.
 */
const HorseProfile: React.FC = () => {
  const { layout } = useChartLayout();
  return layout === 'modern' ? <HorseProfileModern /> : <HorseProfileClassic />;
};

export default HorseProfile;
